package com.essntl.features.itinerary.ui.edit_itinerary.components

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import com.essntl.features.client.domain.model.ClientModel
import com.essntl.features.client.ui.ClientItem
import com.essntl.features.itinerary.domain.model.ItineraryModel
import com.essntl.features.itinerary.ui.edit_itinerary.EditItineraryEvent
import com.essntl.features.itinerary.ui.edit_itinerary.EditItineraryNavigation
import com.essntl.uikit.components.button.primary.EsLargePrimaryButton
import com.essntl.uikit.components.button.primary.EsMediumPrimaryButton
import com.essntl.uikit.components.button.secondary.EsLargeSecondaryButton
import com.essntl.uikit.components.dialog.EsDialog
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.input.EsInput
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.rememberEquals
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun ItineraryServicesClientsDialog(
    onDismissRequest: () -> Unit,
    clients: List<ClientModel>,
    itinerary: ItineraryModel,
    onEvent: (EditItineraryEvent) -> Unit,
    onNavigation: (EditItineraryNavigation) -> Unit,
) {
    var guestDetails by remember { mutableStateOf(itinerary.proposal?.guestDetails ?: "") }

    EsDialog(
        title = "Travellers",
        onDismissRequest = onDismissRequest,
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .padding(2f.spacing),
        ) {
            Row(
                verticalAlignment = Alignment.Bottom,
                horizontalArrangement = Arrangement.spacedBy(2.spacing),
                modifier = Modifier.fillMaxWidth(),
            ) {
                EsInput(
                    value = guestDetails,
                    onValueChange = {
                        guestDetails = it
                    },
                    label = "Details",
                    singleLine = false,
                    modifier = Modifier.weight(3F),
                )

                EsMediumPrimaryButton(
                    onClick = {
                        onEvent(EditItineraryEvent.UpdateClientDetails(guestDetails))
                    },
                    text = "Update",
                    suffixIconRes = EsIcons.Edit,
                    modifier = Modifier.weight(1F),
                )
            }

            Spacer(modifier = Modifier.height(2.spacing))

            if (clients.isEmpty())
                Text(
                    text = "There are no clients created here",
                    textAlign = TextAlign.Start,
                    style = MaterialTheme.esTypography.p1Regular16,
                    color = MaterialTheme.esColorScheme.textPrimary,
                )
            else
                LazyColumn(
                    verticalArrangement = Arrangement.spacedBy(1.spacing),
                    modifier = Modifier.heightIn(max = 450.dp),
                ) {
                    items(clients) { client ->
                        val isPrimaryClient =
                            rememberEquals(
                                itinerary.proposal?.primaryClient?.id,
                                setOf(client.id),
                            ) { it }

                        ClientItem(
                            client = client,
                            isPrimaryClient = isPrimaryClient,
                            onSetClientPrimary = {
                                onEvent(EditItineraryEvent.SetPrimaryClient(client))
                            },
                            onDeleteClient = {
                                onEvent(EditItineraryEvent.DeleteClient(client))
                            },
                            onEditClient = {
                                onNavigation(EditItineraryNavigation.EditClient(client))
                            },
                            modifier = Modifier.fillMaxWidth(),
                        )
                    }
                }

            Spacer(modifier = Modifier.height(2.spacing))

            Row(
                horizontalArrangement = Arrangement.spacedBy(1.spacing),
                modifier = Modifier.fillMaxWidth(),
            ) {
                EsLargePrimaryButton(
                    onClick = {
                        onNavigation(EditItineraryNavigation.AddClient)
                    },
                    text = "Add new",
                    suffixIconRes = EsIcons.Add,
                    enabled = true,
                    modifier = Modifier.weight(1f),
                )

                EsLargeSecondaryButton(
                    onClick = {
                        onNavigation(EditItineraryNavigation.SelectClient)
                    },
                    text = "Add existing",
                    suffixIconRes = EsIcons.Add,
                    enabled = true,
                    modifier = Modifier.weight(1f),
                )
            }
        }
    }
}